export default __webpack_public_path__ + "static/4-b014f8f9951c96d66419e996cba8c4b6.jpg";